import { TBasicCustomEvents, TCustomEvents } from '../types/events';

export function sendEvent<T extends TBasicCustomEvents>(eventName: T): void;
export function sendEvent<T extends keyof TCustomEvents>(eventName: T, data: TCustomEvents[T]): void;
/**
 * Формирует и отправляет нативные события в объект Window.
 * Может передавать какие-то данные, которые будут доступны в поле `detail`.
 */
export function sendEvent(eventName: string, data?: unknown): void {
  if (typeof window !== 'undefined') {
    let event;

    if (data) {
      event = new CustomEvent(eventName, { detail: data });
    } else {
      event = new Event(eventName);
    }

    window.dispatchEvent(event);
  }
}
